import { useHistory, useLocation } from "react-router-dom";
import "../../exam/components/PracticeSummaryComponent.css";
import images from "../../../../utilities/images/images";
import {
  readHomeworkPracticeSummary,
  readPyqPracticeSummary,
} from "../utils/exerciseExamUtils";

const ExercisePracticeSummaryPage = () => {
  const history = useHistory();
  const location = useLocation();
  const isHomeworkSummary = String(location.pathname || "").includes(
    "homework"
  );
  const summary =
    location.state?.summary ||
    (isHomeworkSummary
      ? readHomeworkPracticeSummary()
      : readPyqPracticeSummary());

  const handleBack = () => {
    history.push({
      pathname:
        summary?.returnTo ||
        (isHomeworkSummary ? "/homework" : "/topic_component"),
      state: summary?.returnState || (isHomeworkSummary ? undefined : { tab: "pyq" }),
    });
  };

  const handleViewSolution = () => {
    if (!summary?.viewSolutionPath) return;
    history.push(summary.viewSolutionPath);
  };

  if (!summary) {
    return (
      <div className="ps-wrapper">
        <p style={{ textAlign: "center" }}>
          {isHomeworkSummary
            ? "Homework summary not available."
            : "Practice summary not available."}
        </p>
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <button className="btn-dark" onClick={handleBack}>
            Back To Tests
          </button>
        </div>
      </div>
    );
  }

  const accuracyDisplay = String(summary.accuracy ?? "")
    .trim()
    .replace(/%+\s*$/, "");

  return (
    <div className="ps-wrapper">
      <div className="ps-header">
        <span className="ps-back" onClick={handleBack}>
          <img src={images.new_backarrow} alt="back arrow" />
        </span>
        <h2 className="ps-heading">
          {isHomeworkSummary ? "Homework Summary" : "Practice Summary"}
        </h2>
      </div>

      <div className="ps-alert">• This summary will not be saved</div>

      <h3 className="ps-title">{summary.test_name}</h3>

      <div className="ps-metrics-wrapper">
        <div className="ps-metrics-box">
          <h4 className="ps-section-title">Performance Metrics</h4>

          <div className="ps-performance-grid">
            <div className="ps-card ps-accuracy">
              <div className="ps-circle">
                <span className="ps-percent">{accuracyDisplay}%</span>
                <span className="ps-label">Accuracy</span>
              </div>
            </div>

            <div className="ps-card">
              <h4>{summary.attempted}</h4>
              <p>Attempted Q’s</p>
            </div>

            <div className="ps-card">
              <h4>{summary.time_spent}</h4>
              <p>Time Spent</p>
            </div>
          </div>
        </div>

        <div className="ps-metrics-box">
          <h4 className="ps-section-title">Question Breakdown</h4>

          <div className="ps-breakdown-grid">
            {summary.question_breakdown?.map((item) => (
              <div
                key={item.id}
                className="ps-card"
                style={{
                  background: item.bg_color,
                  border: `1px solid ${item.border_color}`,
                  color: item.value_text_color,
                }}
              >
                <h4 style={{ color: item.value_text_color }}>{item.value}</h4>
                <p style={{ color: item.value_text_color }}>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className={`ps-actions ${
          summary.viewSolutionPath ? "" : "ps-actions--end"
        }`}
      >
        {summary.viewSolutionPath ? (
          <button className="btn-outline" onClick={handleViewSolution}>
            View Solution
          </button>
        ) : null}
        <button className="btn-dark" onClick={handleBack}>
          Back To Tests
        </button>
      </div>
    </div>
  );
};

export default ExercisePracticeSummaryPage;
